import { store } from '@/store/index'

export default async(to, from, next) => {
  const url_id = store.state.selected_outlet.url_id
  if (url_id === '' || url_id === null) {
    if (to.name !== 'home' && to.name !== 'listoutlets' && to.name !== '_splash') {
      const astra_outlet = store.state.store_astra
      const tmii_outlet = store.state.store_tmii
      const url_id = store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        next({ name: 'home' })
      }
    }
  }
}
